import { OrganizationModels, UserOrganizationDropDown } from '@models/organization.model';

export function toDropdownOrganization(
  document: OrganizationModels.OrganizationDocument,
): UserOrganizationDropDown {
  return {
    id: document._id,
    name: document.settings.orgName,
    logo: '',
    color: document.settings.orgColor,
    isDeletePermission: false,
  };
}
